import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ApiService from "../../../services/api";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import "../css/compositions_page_category_single.css";
import Players from "../../home_components/album/components/players";
import parse from "html-react-parser";
import { AuthContext } from "../../../services/auth";

const CompositionsPageCategorySingle = () => {
  const [indexMusic, setIndexMusic] = useState(0);
  const { isEnglish } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [istrue, setIstrue] = useState(false);
  const [compositions, setCompositions] = useState([]);
  const [Loading, setLoading] = useState(true);
  const { slugMusic } = useParams();

  const fetchCompositions = async () => {
    const Compositions = await ApiService.getAlbumsCategorySinge(slugMusic);
    setCompositions(Compositions);
    setLoading(false);
  };

  useEffect(() => {
    fetchCompositions();
  }, [slugMusic]);

  if (Loading) {
    return;
  }

  const handleClose = () => setShow(false);

  const buttonBlockChild = (data) => {
    setIstrue(data);
  };

  return (
    <Container fluid className="m-0 p-0 ">
      <Container
        fluid
        className="p-0 text-center bg-black object-fit-contain ParallaxBanner-compositions-single"
      >
        <img
          src={compositions.img}
          className="img-ParallaxBanner-compositions-single parallax_bio"
          alt=""
        ></img>

        <Container
          fluid
          style={{ zIndex: "10" }}
          className="text_hero text-center d-flex justify-content-center align-items-center margin-custom-page-single"
        >
          <img
            src={compositions.img}
            className="img-contained-parallaxBanner"
            alt=""
          ></img>
        </Container>
      </Container>
      <Container className="container-body-compositions-page text-center d-flex justify-content-center align-items-center w-100">
        <Container className="container-compositions-page d-flex justify-content-center align-items-center bg-white p-0 m-0">
          <Row className="w-100 p-0 m-0 d-flex align-items-center justify-content-center mb-5">
            <Col className="col-12 my-5 p-0">
              <h2 className="text-center section-title text-uppercase title_data">
                {compositions.title}
              </h2>
              <div className="border-custom mt-3"></div>
            </Col>
            <Row className="w-100 p-0 m-0">
              {compositions.music_tracks?.length === 1 && (
                <Col className="d-flex align-items-center justify-content-center my-3">
                  <Button
                    variant=""
                    className="color-container-track-video-composition-page py-2"
                    onClick={() => {
                      setIstrue(true);
                    }}
                  >
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-music-note" viewBox="0 0 16 16">
                        <path d="M9 13c0 1.105-1.12 2-2.5 2S4 14.105 4 13s1.12-2 2.5-2 2.5.895 2.5 2"/>
                        <path fill-rule="evenodd" d="M9 3v10H8V3z"/>
                        <path d="M8 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 13 2.22V4L8 5z"/>
                      </svg>
                      <span className="ms-2">{isEnglish ? "Listen" : "Ascolta"}</span>
                  </Button>
                </Col>
              )}
              {compositions.videos && (
                <Col className=" d-flex align-items-center justify-content-center my-3">
                  <Button
                    variant=""
                    className="color-container-track-video-composition-page py-2 "
                    onClick={() => {
                      setIstrue(false);
                      document.body.classList.remove("visualized");
                      setShow(true);
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-play-btn" viewBox="0 0 16 16">
                      <path d="M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z"/>
                      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z"/>
                    </svg>
                    <span className="ms-2">{isEnglish ? "Video" : "Video"}</span>
                  </Button>
                </Col>
              )}
            </Row>
            {compositions.music_tracks?.length >= 2 && (
              <Row className=" p-3 margin-custom-multy-truck">
                <div className="mb-4">
                  <h4 className="text-center section-title title_data">
                    {isEnglish ? "Tracks" : "Tracce"}
                  </h4>
                  <div className="border-custom mt-3"></div>
                </div>
                <div className="d-flex justify-content-center">
                  <ul className="margin-custom-ul">
                    {compositions.music_tracks.map((music, index) => {
                      return (
                        <li className="col-12 p-2" key={index}>
                          <h5
                            className="p-0 m-0 text-start h6-multiple-play"
                            onClick={() => {
                              setIndexMusic(index);
                              setIstrue(true);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              fill="currentColor"
                              className="bi bi-play-fill mb-1"
                              viewBox="0 0 16 16"
                            >
                              <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393" />
                            </svg>
                            {music.name}
                          </h5>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </Row>
            )}
          </Row>
        </Container>
      </Container>
      {(compositions.description || compositions.description_eng) && (
        <Container fluid className="p-0 margin-custom-description px-5 ">
          <h4 className="section-text mt-5">
            {isEnglish
              ? parse(compositions.description_eng)
              : parse(compositions.description)}
          </h4>
        </Container>
      )}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body className="container_modal d-flex justify-content-center align-items-center p-0 bg-black">
          <iframe
            title="video"
            src={compositions.videos}
            className="w-100 container_modal p-0"
            allowFullScreen
          ></iframe>
        </Modal.Body>
      </Modal>
      {istrue && (
        <Players
          index={indexMusic}
          music={compositions.music_tracks}
          buttonBlockChild={buttonBlockChild}
        />
      )}
    </Container>
  );
};
export default CompositionsPageCategorySingle;
